// src/layouts/ExpertDashboardLayout.tsx
import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Phone, X, Mail } from 'lucide-react';

import { useExpertLogout } from '../hooks/expertLoginHooks/useExpertLogout'; 
import { useExpertDashboard } from '../hooks/expertDashboardHooks/useExpertDashboard';
import { useExpertActivity } from '../hooks/useExpertActivity';
import { ExpertSidebar } from '../dashboards/expertDashboard/ExpertSidebar';
import { ExpertNavbar } from '../dashboards/expertDashboard/ExpertNavbar';

export function ExpertDashboardLayout() {
  const { logout } = useExpertLogout(); 
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false); 
  const [expertCode, setExpertCode] = useState("");

  const { dashboardData } = useExpertDashboard();
  const { availability,  toggleStatus, isUpdating } = useExpertActivity(expertCode);

  useEffect(() => {
    const code = localStorage.getItem('expertCode') || localStorage.getItem('expert_code');
    if (code) setExpertCode(code);
  }, []);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const displayName = dashboardData?.fullName || localStorage.getItem('expertName') || "Expert";
  const profileImage = dashboardData?.profileImage; 

  return (
    <div className="min-h-screen bg-gray-50 flex font-sans">
      <ExpertSidebar 
        isOpen={isSidebarOpen} 
        onClose={toggleSidebar} 
        expertName={displayName} 
        expertCode={expertCode} 
        profileImage={profileImage} 
        onLogout={logout} 
        onSettingsClick={() => setIsSettingsOpen(true)} 
      />
      <div className="flex-1 flex flex-col h-screen overflow-hidden relative">
        <ExpertNavbar 
          onMenuClick={toggleSidebar} 
          availability={availability} 
          onToggleStatus={toggleStatus} 
          isUpdating={isUpdating} 
        />
        
        <div className="flex-1 overflow-y-auto bg-gray-50">
          <Outlet />
        </div>

        {isSettingsOpen && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden p-6 relative">
              <button onClick={() => setIsSettingsOpen(false)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"><X /></button>
              <h3 className="font-bold text-lg mb-4">Expert Profile Settings</h3>
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center text-xl font-bold text-blue-600">{displayName[0]}</div>
                <div><h4 className="font-bold">{displayName}</h4><p className="text-xs text-gray-500">CODE: {expertCode}</p></div>
              </div>
              <div className="space-y-4">
                <div className="flex gap-3 text-sm"><Mail className="w-4 h-4 text-gray-400" /> {dashboardData?.email || 'N/A'}</div>
                <div className="flex gap-3 text-sm"><Phone className="w-4 h-4 text-gray-400" /> {dashboardData?.phone || 'N/A'}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}